/**
 * Ссылки на оферту и политику конфиденциальности.
 *
 * Документы открываются во внешнем браузере: это юридический текст,
 * его читают целиком, а не во встроенном окне поверх приложения.
 */
import { config } from '@/shared/config/env';
import { openExternal } from '@/shared/lib/links';

import styles from './LegalLinks.module.css';

const DOCUMENTS = [
  { title: 'Публичная оферта', url: config.offerUrl },
  { title: 'Политика конфиденциальности', url: config.privacyUrl },
];

export function LegalLinks() {
  return (
    <nav className={styles.links} aria-label="Документы">
      {DOCUMENTS.map(({ title, url }) => (
        <button
          key={title}
          type="button"
          className={styles.link}
          onClick={() => openExternal(url)}
        >
          {title}
        </button>
      ))}
    </nav>
  );
}
